import { render, staticRenderFns } from "./CallsDialog.vue?vue&type=template&id=63bb2f23&scoped=true&"
import script from "./CallsDialog.vue?vue&type=script&lang=ts&"
export * from "./CallsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bb2f23",
  null
  
)

export default component.exports